import DateUtils from './date-utils';

export class DateWithFormat {
  dateFormat: string;
  date: string;

  constructor(date?: string) {
    if (date) {
      this.date = date;
      this.dateFormat = DateUtils.parseDateFormat(date);
    }
  }
}


// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/shared/date-with-format.ts